<template>
    <div class="form-group">
        <div class="container-fluid">
            <div class="row">
                <template v-for="(item, key) in items">

                    <div :class="classColumn(key)" :key="key">
                        <div v-for="(element,index) in item" :key="index">

                            <template v-if="element.container">
                                <component :class="elementCssClass(element)"
                                           ref="container"
                                           v-model="element.items"
                                           :transientData="transientData"
                                           @submit="submit"
                                           @pageNavigate="pageNavigate"
                                           :config="element.config"
                                           :is="element['component']">
                                </component>
                            </template>

                            <template v-else>
                                <div :id="element.config.name ? element.config.name : undefined">
                                    <component :class="elementCssClass(element)"
                                               ref="elements"
                                               v-model="model[element.config.name]"
                                               :validationData="transientData"
                                               @submit="submit"
                                               @pageNavigate="pageNavigate"
                                               v-bind="element.config"
                                               :is="element['component']"
                                               v-show="showElement[element.config.name] !== undefined ? showElement[element.config.name] : true">
                                    </component>
                                </div>
                            </template>
                        </div>
                    </div>

                </template>
            </div>
        </div>
    </div>
</template>

<script>
  import draggable from "vuedraggable";

  import FormMultiColumn from "./form-multi-column";
  import HasColorProperty from "../../mixins/HasColorProperty";

  import FormText from "../renderer/form-text";
  import FormButton from "../renderer/form-button";
  import FormImage from "../renderer/form-image";

  import {
    FormInput,
    FormSelect,
    FormTextArea,
    FormCheckbox,
    FormRadioButtonGroup,
    FormDatePicker
  } from "@processmaker/vue-form-elements/src/components";

  export default {
    name: "FormMultiColumn",
    mixins: [HasColorProperty],
    props: ["value", "selected", "name", "config", "transientData"],
    components: {
      draggable,
      FormInput,
      FormSelect,
      FormTextArea,
      FormCheckbox,
      FormRadioButtonGroup,
      FormText,
      FormButton,
      FormMultiColumn,
      FormDatePicker,
      FormImage
    },
    data() {
      return {
        items: []
      };
    },
    computed: {
      model() {
        return this.$parent.model;
      },
      showElement() {
        return this.$parent.showElement;
      }
    },
    watch: {
      value: {
        handler: function () {
          this.items = this.value;
        },
        immediate: true
      },
      items() {
        this.$emit("input", this.items);
      }
    },
    methods: {
      classColumn(index) {
        let column = 1;
        if (this.items.length < this.config.options.length) {
          this.items.push([]);
        }
        if (this.config.options[index] && this.config.options[index].content) {
          column = this.config.options[index].content;
        }

        return "col-sm-" + column + " column-draggable " + this.columnVerticalAlign(index);
      },
      columnVerticalAlign (index) {
        let verticalAlignClass = '';

        if (this.items.length > 0
           && this.items[index].length > 0) {
            let formTexts  = this.items[0].filter(item => item.component === 'FormText');
            if (formTexts.length === 0) {
               return '';
            }

            let formText = formTexts[0];
            switch (formText.config.verticalAlign) {
                case 'top':
                    verticalAlignClass = 'd-flex align-items-start';
                    break;
                case 'middle':
                    verticalAlignClass = 'd-flex align-items-center';
                    break;
                case 'bottom':
                    verticalAlignClass = 'd-flex align-items-end';
                    break;
            }
        }
        return verticalAlignClass;
      },
      inspect(element) {
        this.$emit("inspect", element);
      },
      submit() {
        // Just bubble up
        this.$emit("submit");
      },
      pageNavigate(page) {
        // Just bubble up
        this.$emit("pageNavigate", page);
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>

